// @flow

import React, { type Node, useMemo } from 'react';
import { Hr, Inline, Box, Margin, Padding } from '../../../atoms';
import { timesGroupSplitter, timesGroupSlicer } from '@tectonics/look-and-feel/commons/format-utils';
import styled from 'styled-components';

type OxxoNumberProps = {|
  oxxoCode: string,
|};

function useSafeSplitOxxoCode(oxxoCode: string): ImmutableArray<string> {
  const splitOxxoCode = useMemo(() => timesGroupSplitter(4, oxxoCode), [oxxoCode]);
  if (!splitOxxoCode.length) {
    throw new Error('Split Oxxo Code is Null');
  }
  return splitOxxoCode;
}

export function OxxoNumber({ oxxoCode }: OxxoNumberProps): Node {
  const splitOxxoCode = useSafeSplitOxxoCode(oxxoCode);

  return(
    <div>
      {timesGroupSlicer(4, splitOxxoCode).map((slice, index) => (
        <Frgmt key={index}>
          <OxxoNumberRow oxxoNumberGroupArray={slice} />
          {index > 0 && <Hr to="ts" size={0} />}
        </Frgmt>
      ))}
    </div>
  );
}

type OxxoNumberRowProps = {|
    oxxoNumberGroupArray: Array<string>,
|};

function OxxoNumberRow({ oxxoNumberGroupArray }: OxxoNumberRowProps ): Node {
  return(oxxoNumberGroupArray.map((element, index)=> {
    return (
      <Element key={index}>
        <Margin size={0.2}>
          <Box flavor="info" variation="light">
            <Padding size={0.2}>
              <strong>{element}</strong>
            </Padding>
          </Box>
        </Margin>
      </Element>
    );
  }));
}

const Frgmt = styled.div`
  display: flex;
  width: 80%;
  margin: 0 auto;
  @media screen and (min-width: 800px) {
    width: 60%;
  }
`;

const Element = styled(Inline)`
  flex-basis: 25%;
  font-size: 1.2em;
  padding: 0.25em;
`;
